var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('b-row',[_c('b-col',{staticClass:"col-nav",attrs:{"cols":"6"}},[_c('nav-component')],1),_c('b-col',{staticClass:"col-nav",attrs:{"cols":"6"}},[_c('font-control')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }